(function (angular) {
    'use strict';

    angular.module('sms')
        /**
         *
         */
        .controller('trackingCtrl',
        ['$scope', 'trackingService', 'trackingData', '$stateParams', 'growlService', '$uibModalInstance', 'utilService',
                function ($scope, trackingService, trackingData, $stateParams, growlService, $uibModalInstance, utilService) {

                    $scope.trackingData = trackingData;

                    $scope.validateClickForwardUrl = function () {
                        if(!$scope.tracking){
                            $scope.isClickForwardUrlValid = utilService.validateUrl($scope.trackingData.clickForwardUrl, false);
                            return;
                        }
                        $scope.isClickForwardUrlValid = utilService.validateUrl($scope.tracking.clickForwardUrl, false);
                        return;
                    };

                    $scope.validateClickForwardUrl();

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $scope.updateScope = function () {
                        $scope.tracking = angular.copy($scope.trackingData);
                    };
                    $scope.prepareData = function () {
                        return {
                            "allUrls": $scope.tracking.allUrls,
                            "markedUrls": $scope.tracking.markedUrls,
                            "urlPrefix": $scope.tracking.urlPrefix,
                            "urlPrefixData": $scope.tracking.urlPrefixData,
                            "customDomain": $scope.tracking.customDomain,
                            "customDomainData": $scope.tracking.customDomainData,
                            "clickForwardUrl": $scope.tracking.clickForwardUrl
                        };
                    };
                    $scope.setTrackAllUrls = function () {
                        if ($scope.tracking.allUrls) {
                            $scope.trackingData.markedUrls = false;
                            $scope.tracking.markedUrls = false;
                        }
                        trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                            $scope.trackingData.allUrls = $scope.tracking.allUrls;
                            growlService.success("Tracking all URL's was set");
                        }).catch(function (error) {
                            growlService.danger("Track all URL's wasn't set due to: " + error.statusText);
                            $scope.updateScope();
                        });
                    };
                    $scope.setTrackMarkedUrls = function () {
                        if ($scope.tracking.markedUrls) {
                            $scope.trackingData.allUrls = false;
                            $scope.tracking.allUrls = false;
                        }
                        trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                            $scope.trackingData.markedUrls = $scope.tracking.markedUrls;
                            growlService.success("Tracking marked URL's was set");
                        }).catch(function (error) {
                            growlService.danger("Track marked URL's wasn't set due to: " + error.statusText);
                            $scope.updateScope();
                        });
                    };
                    $scope.setUrlPrefix = function () {
                        if (!$scope.tracking.urlPrefix) {

                            $scope.trackingData.urlPrefixData = '';
                            $scope.tracking.urlPrefixData = '';

                            trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                                $scope.trackingData.urlPrefix = $scope.tracking.urlPrefix;
                                growlService.success("Url prefix was set");
                            }).catch(function (error) {
                                growlService.danger("Url prefix wasn't set due to: " + error.statusText);
                                $scope.updateScope();
                            });
                        }
                    };
                    $scope.setUrlPrefixData = function () {
                        trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                            $scope.trackingData.urlPrefixData = $scope.tracking.urlPrefixData;
                            growlService.success("Url prefix data was set");
                        }).catch(function (error) {
                            growlService.danger("Url prefix data wasn't set due to: " + error.statusText);
                            $scope.updateScope();
                        });
                    };
                    $scope.setClickForwardUrl = function () {
                        trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                            $scope.trackingData.clickForwardUrl = $scope.tracking.clickForwardUrl;
                            growlService.success("Click tracking url was set");
                        }).catch(function (error) {
                            growlService.danger("Click tracking url wasn't set due to: " + error.statusText);
                            $scope.updateScope();
                        });
                    }
                    $scope.cancelUrlPrefixData = function () {
                        growlService.success("Cancelled prefix data setting");
                        $scope.updateScope();
                    };
                    $scope.setCustomDomain = function () {
                        if (!$scope.tracking.customDomain) {

                            $scope.trackingData.customDomainData = '';
                            $scope.tracking.customDomainData = '';

                            trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                                $scope.trackingData.customDomain = $scope.tracking.customDomain;
                                growlService.success("Custom domain was set");
                            }).catch(function (error) {
                                growlService.danger("Custom domain wasn't set due to: " + error.statusText);
                                $scope.updateScope();
                            });
                        }
                    };
                    $scope.setCustomDomainData = function () {
                        trackingService.setAllTrackingData($stateParams.pickedApiSpaceId, $scope.prepareData()).then(function (response) {
                            $scope.trackingData.customDomainData = $scope.tracking.customDomainData;
                            growlService.success("Custom domain data was set");
                        }).catch(function (error) {
                            growlService.danger("Custom domain data wasn't set due to: " + error.statusText);
                            $scope.updateScope();
                        });
                    };
                    $scope.cancelCustomDomainData = function () {
                        growlService.success("Cancelled custom domain data setting");
                        $scope.updateScope();
                    };

                    $scope.updateScope();
                }]);


})(window.angular);
